export default __webpack_public_path__ + "static/media/fireicon1.ae55e415.svg";